import SavedViewsComponent from './saved_views_component';
import * as constants from './constants';

export { constants };

export default SavedViewsComponent;
